<template>
  <div class="data-details__action d-flex flex-nowrap" :title="!showTitle ? actionTitle : ''" @click="open">
    <span>
      <AddToItineraryActionIcon />
    </span>
    <span v-if="showTitle">{{ actionTitle }}</span>
    <div v-if="showModal" class="action-modal-backdrop" @click.stop="close" />

    <Transition name="slide">
      <AddToItineraryModal v-if="showModal" :event="event" @close="close" />
    </Transition>
  </div>
</template>

<script>
import AddToItineraryActionIcon from '@/components/icons/AddToItineraryActionIcon.vue';
import CtaClickedGaEvent from '@/helpers/ga/events/CtaClickedGaEvent';
import { getContentTypeFromEntityType } from '@/helpers/ga/params/contentTypeParam';
import { sendGaEvent } from '@/helpers/ga/gaSend';

export default {
  components: {
    AddToItineraryActionIcon,
    AddToItineraryModal: () => import('@/components/partials/AddToItineraryModal.vue'),
  },
  props: {
    event: {
      type: Object,
      required: true,
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      actionTitle: 'Add to Itinerary',
      showModal: false,
    };
  },

  methods: {
    open() {
      this.showModal = true;

      const gaEvent = new CtaClickedGaEvent(this.actionTitle)
        .addContentType(getContentTypeFromEntityType(this.event.__typename))
        .addContentId(this.event.id)
        .addContentName(this.event.title);

      sendGaEvent(gaEvent);
    },
    close() {
      this.showModal = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables-site/variables' as vars;

.action-modal-backdrop {
  display: none;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 998;

  @media (min-width: vars.$tablet-break-point + 1px) {
    display: block;
  }
}
</style>
